import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
export default class Home {
    constructor() {
        // Home

        this.resizeDecor();
        
        window.addEventListener('resize', () => {
            this.resizeDecor();
        });

        this.slider();
    }

    resizeDecor() {
        const element = document.querySelector('.pres__figurePate');

        if (element) {
            element.style.width = window.innerWidth - Tools.offset(element).left;
        }
    }

    slider() {
        tns({
            container: document.querySelector('.avis__slider'),
            items: 1,
            slideBy: 1,
            autoplay: false,
            gutter: 30,
            loop: false,
            mouseDrag: true,
            nav: true,
            navPosition: 'bottom',
            controls: true,
            controlsPosition: 'bottom',
            speed: 650,
            controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="13.778" height="15.63" viewBox="0 0 13.778 15.63"><path id="Tracé_245" data-name="Tracé 245" d="M884.548,86.592c2.487.044,4.383-2.075,6.161-3.815a29.624,29.624,0,0,1,6.711-4.929c-.833.447-6.214-3.259-7.11-3.784-1.057-.621-4.678-3.785-6.013-2.967-1.623.994.283,13.114.251,15.5" transform="translate(-883.642 -70.963)" fill="#51569d"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="13.778" height="15.63" viewBox="0 0 13.778 15.63"><path id="Tracé_245" data-name="Tracé 245" d="M884.548,86.592c2.487.044,4.383-2.075,6.161-3.815a29.624,29.624,0,0,1,6.711-4.929c-.833.447-6.214-3.259-7.11-3.784-1.057-.621-4.678-3.785-6.013-2.967-1.623.994.283,13.114.251,15.5" transform="translate(-883.642 -70.963)" fill="#51569d"/></svg>'],
        });
    }
}